import { fetchLoginCall } from "../ajax";
import { API_CONSTANTS, API_METHODS } from "../api-constant";

export const GetApiKeyList = async (id) => {
  const url = `${API_CONSTANTS.GET_API_KEY_LIST}?healthProfessionalId=${id}`;
  return fetchLoginCall(url, API_METHODS.GET);
};

export const AddOrUpdateApiKey = async (payload) => {
  const url = `${API_CONSTANTS.ADD_OR_UPDATE_APP_KEY}`;
  return fetchLoginCall(url, API_METHODS.POST, payload);
};

export const GetAppKeys = async (id) => {
  const url = `${API_CONSTANTS.GET_APP_KEYS}?healthProfessionalId=${id}`;
  return fetchLoginCall(url, API_METHODS.GET);
};
